<template>
  <div class="hover:bg-gray-100 cursor-pointer p-2 rounded-sm h-14 border-b" :class="{'bg-gray-100': selectedPerson ? person.person_id === selectedPerson.id : '' }" @click="$emit('selected', person)">
    <div class="text-gray-900 text-base">{{ person.person_name }}</div>
    <div :class="setStatus">{{ `${country} - ${role} ${roleDateRange}` }}</div>
  </div>
</template>

<script>
  export default {
    name: '',
    components: {
    },
    data () {
      return {
        people: [],
        setStatus: '',
      }
    },
    created () {
      console.log("person: ", this.person)

      if (this.person.person_role_status == "active") {
        this.setStatus = 'text-gray-600 text-sm status-active-person-select'
      } else if (this.person.person_role_status == "inactive" || this.person.person_role_status == "suspended") {
        this.setStatus = 'text-gray-600 text-sm status-inactive-person-select'
      } else if (this.person.person_role_status == "graduated") {
        this.setStatus = 'text-gray-600 text-sm status-graduated-person-select'
      } else if (this.person.person_role_status == "dropped") {
        this.setStatus = 'text-gray-600 text-sm status-dropped-person-select'
      } else if (this.person.person_role_status == "under_review") {
        this.setStatus = 'text-gray-600 text-sm status-under-review-person-select'
      } else {
        this.setStatus = 'text-gray-600 text-sm status-inactive'
      }
    },
    computed: {
      label () {
        return `${this.person.person_name} - ${this.countryName}`
      },
      country () {
        return this.person.country_name || 'Unknown'
      },
      role () {

        if (this.person.role.includes('_')) {
          let roleString = ''

          this.person.role.split('_').forEach(i => {
            roleString = roleString + `${i[0].toUpperCase() + i.slice(1)} `
          })

          return roleString
        }

        return this.person.role[0].toUpperCase() + this.person.role.slice(1)
      },
      roleDateRange () {
        let startDate = this.person.role_effective_at || this.person.role_estimated_effective_at || this.person.role_created_at
        let endDate = this.person.role_ineffective_at || this.person.role_estimated_ineffective_at

        return `(${startDate ? startDate.substring(0,4) : ' '} - ${endDate ? endDate.substring(0,4) : ' '})`
      }
    },
    methods: {
    },
    props: {
      person: {
        type: Object,
        required: true,
      },
      selectedPerson: {
        type: Object,
        required: false,
      },
    },
    watch: {
    },
  }
</script>

<style lang="scss">
  .status-active-person-select:after {
    @apply inline-block align-middle text-green-400 bg-green-100 rounded-lg w-4 h-4 ml-3;
    content: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='%2331c48d' viewBox='0 0 492 492'><g><path d='M246,478.29A231.1,231.1,0,0,1,82.59,83.77,231.1,231.1,0,0,1,409.41,410.6,229.58,229.58,0,0,1,246,478.29Zm0-417.21c-102.62,0-186.1,83.49-186.1,186.11s83.48,186.1,186.1,186.1,186.1-83.49,186.1-186.1S348.62,61.08,246,61.08Z'/><path d='M213.78,353.54A22.5,22.5,0,0,1,197.87,347l-70.75-70.76a22.5,22.5,0,1,1,31.82-31.82l53,53.05,119.48-148.2a22.5,22.5,0,1,1,35,28.24l-135.2,167.7A22.48,22.48,0,0,1,215,353.5C214.58,353.52,214.18,353.54,213.78,353.54Z'/></g></svg>");
    cursor: pointer;
  }

  .status-inactive-person-select:after {
    @apply inline-block align-middle text-blue-400 bg-green-100 rounded-lg w-4 h-4 ml-3;
    content: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='%23f98080' viewBox='0 0 492 492'><g><path d='M246,478.29A231.1,231.1,0,0,1,82.59,83.77,231.1,231.1,0,0,1,409.41,410.6,229.58,229.58,0,0,1,246,478.29Zm0-417.21c-102.62,0-186.1,83.49-186.1,186.11s83.48,186.1,186.1,186.1,186.1-83.49,186.1-186.1S348.62,61.08,246,61.08Z'/><path d='M213.78,353.54A22.5,22.5,0,0,1,197.87,347l-70.75-70.76a22.5,22.5,0,1,1,31.82-31.82l53,53.05,119.48-148.2a22.5,22.5,0,1,1,35,28.24l-135.2,167.7A22.48,22.48,0,0,1,215,353.5C214.58,353.52,214.18,353.54,213.78,353.54Z'/></g></svg>");
    cursor: pointer;
  }

  .status-dropped-person-select:after {
    content: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='%23f98080' viewBox='0 0 492 492'><g><path d='M409.41,83.38A231.1,231.1,0,0,0,82.59,410.21,231.1,231.1,0,0,0,409.41,83.38ZM246,432.9c-102.62,0-186.1-83.49-186.1-186.11S143.38,60.69,246,60.69s186.1,83.49,186.1,186.1S348.62,432.9,246,432.9Z'/><path d='M343.26,312.23a22.5,22.5,0,0,1-31.82,31.82l-65-65-65.05,65a22.5,22.5,0,0,1-31.82-31.82l65.05-65-65.05-65.05a22.5,22.5,0,0,1,31.82-31.82l65.05,65.05,65-65.05a22.5,22.5,0,1,1,31.82,31.82l-65,65.05Z'/></g></svg>");
    @apply inline-block align-middle text-red-400 bg-red-100 rounded-lg w-4 h-4 ml-3;
    cursor: pointer;
  }

  .status-graduated-person-select:after {
    content: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='%2347a9ff' viewBox='0 0 492 492'><polygon points='250.22 102.48 451.65 194.33 475.07 205.01 451.52 215.42 247.96 305.39 243.24 307.48 238.54 305.35 40.05 215.38 16.93 204.9 40.01 194.33 240.63 102.48 245.41 100.29 250.22 102.48'/><path d='M243.69,323.88l99.67-44.26,16.21-7.19v17.74l0,58v5.17l-3.84,3.43c-73.5,50.22-150.2,49.3-223.91.09l-3.9-3.43v-5.26l.06-57.76,0-17.76,16.18,7.17Z'/><polygon points='46.78 241.02 64.8 310.59 30.72 310.44 46.78 241.02'/><path d='M47,229.48A11.32,11.32,0,1,1,35.7,240.8,11.31,11.31,0,0,1,47,229.48Z'/></svg>");
    @apply inline-block align-middle text-blue-400 w-5 h-5 ml-3;
    cursor: pointer;
  }

  .status-under-review-person-select:after {
    content: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='%23e3a008' viewBox='0 0 492 492'><g><path d='M435,454.11H57a43.77,43.77,0,0,1-37.95-65.56l189-329.17a43.76,43.76,0,0,1,75.9,0l189,329.17A43.77,43.77,0,0,1,435,454.11Zm-375.84-45h373.7L246,83.65ZM247.07,81.78Zm-19.51-11.2h0Z'/><path d='M246,323.75a22.5,22.5,0,0,1-22.5-22.5v-130a22.5,22.5,0,0,1,45,0v130A22.5,22.5,0,0,1,246,323.75Z'/><path d='M272.92,368.57A26.92,26.92,0,1,1,246,341.65,26.95,26.95,0,0,1,272.92,368.57Z'/></g></svg>");
    @apply inline-block align-middle text-yellow-400 w-4 h-4 ml-3;
    cursor: pointer;
  }

  .status-validated-person-select:after {
    @apply inline-block align-middle text-green-400 rounded-lg w-4 h-4 ml-3;
    content: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='%2331c48d' viewBox='0 0 492 492'><path d='M404.77,58.4a10.47,10.47,0,0,0-11,1C352.07,90.68,297.61,76,244.93,61.83c-46.64-12.58-90.67-24.41-123.11-2.78a10.54,10.54,0,0,0-4.67,8.72V422a12.57,12.57,0,1,0,25.14,0V260.72c24.66-9.46,60-.07,97.17,10,30.13,8.11,62.47,16.82,93.76,16.82,25.69,0,50.66-5.86,73.15-22.73a10.46,10.46,0,0,0,4.2-8.38V67.77A10.5,10.5,0,0,0,404.77,58.4Z'/></svg>");
  }

  .status-unvalidated-person-select:after {
    content: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='%23f98080' viewBox='0 0 492 492'><path d='M404.77,58.4a10.47,10.47,0,0,0-11,1C352.07,90.68,297.61,76,244.93,61.83c-46.64-12.58-90.67-24.41-123.11-2.78a10.54,10.54,0,0,0-4.67,8.72V422a12.57,12.57,0,1,0,25.14,0V260.72c24.66-9.46,60-.07,97.17,10,30.13,8.11,62.47,16.82,93.76,16.82,25.69,0,50.66-5.86,73.15-22.73a10.46,10.46,0,0,0,4.2-8.38V67.77A10.5,10.5,0,0,0,404.77,58.4Z'/></svg>");
    @apply inline-block align-middle text-red-400 rounded-lg w-4 h-4 ml-3;
  }
</style>
